import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { InlineButton } from 'ui-components';
import { IkeOrIkzeLimits } from './IkeOrIkze';

interface IkzeDepositLimitProps {
  limits: IkeOrIkzeLimits;
  onOpenDialog?: () => void;
}

const IkzeDepositLimit: React.FC<IkzeDepositLimitProps> = ({ limits, onOpenDialog }) => {
  const { t } = useTranslation('ike-or-ikze');

  return (
    <>
      {t('ikze.annual_deposit_limit', '', { limit: limits.ikzeLimit, year: limits.year })}
      {limits.ikzeEntrepreneurLimit && (
        <Trans
          ns="ike-or-ikze"
          i18nKey="ikze.entrepreneur_annual_deposit_limit"
          values={{ limit: limits.ikzeEntrepreneurLimit, year: limits.year }}
        >
          <InlineButton variant="underline" onClick={onOpenDialog}>samozatrudnionych</InlineButton>
        </Trans>
      )}
    </>
  );
};

export default IkzeDepositLimit;
